import ArrowRight from '@mui/icons-material/ArrowRight';
import {
  ListItemIcon,
  ListItemIconProps,
  MenuItem,
  MenuItemProps,
  Stack,
  Tooltip,
  Typography,
  TypographyProps,
} from '@mui/material';
import { FunctionComponent, MouseEvent, ReactNode, useState, PropsWithChildren } from 'react';

import { ActionsMenu } from 'shared/ActionsMenu/ActionsMenu';

export interface Option extends MenuItemProps {
  hide?: boolean;
  submenu?: Option[];
  label: TypographyProps & { text: string };
  listIcon?: ListItemIconProps & { icon: ReactNode };
  tooltip?: string;
}

export const ActionsMenuItem: FunctionComponent<PropsWithChildren<Option>> = ({
  hide,
  submenu,
  listIcon,
  tooltip = '',
  label: { text, ...typographyProps },
  ...menuItemProps
}) => {
  const [actionsMenuAnchorEl, setActionsMenuAnchorEl] = useState<null | HTMLElement>(null);

  const openActionsMenu = (event: MouseEvent<HTMLElement>) => {
    setActionsMenuAnchorEl(event.currentTarget);
  };

  if (hide) return null;

  if (submenu) {
    return (
      <>
        <MenuItem
          {...menuItemProps}
          onClick={openActionsMenu}
          key={`actions-submenu-option-${text}`}
          sx={{ justifyContent: 'space-between' }}
        >
          <Stack direction="row">
            {listIcon && <ListItemIcon {...listIcon}>{listIcon.icon}</ListItemIcon>}
            <Typography {...typographyProps}>{text}</Typography>
          </Stack>
          <ListItemIcon sx={{ justifyContent: 'flex-end' }}>
            <ArrowRight />
          </ListItemIcon>
        </MenuItem>
        <ActionsMenu
          options={submenu}
          anchorEl={actionsMenuAnchorEl}
          onClose={() => setActionsMenuAnchorEl(null)}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        />
      </>
    );
  }

  const menuItem = (
    <MenuItem {...menuItemProps} title={menuItemProps.disabled ? undefined : tooltip}>
      {listIcon && <ListItemIcon {...listIcon}>{listIcon.icon}</ListItemIcon>}
      <Typography {...typographyProps}>{text}</Typography>
    </MenuItem>
  );

  if (menuItemProps.disabled && tooltip) {
    return (
      <Tooltip title={tooltip} placement="right" arrow>
        <span style={{ display: 'block' }}>{menuItem}</span>
      </Tooltip>
    );
  }

  return menuItem;
};
